"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginSSO = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const public_1 = require("../../../common/public");
const ErrorMessage_1 = require("../../../ErrorMessage");
const fields_1 = require("../../../fields");
const FormLayout_1 = require("../../../layouts/FormLayout");
const constants_1 = require("./helpers/constants");
const LoginSSO_styles_1 = require("./LoginSSO.styles");
const maxLength_1 = require("../../helpers/maxLength");
const hooks_1 = require("../../hooks");
const Spinner_1 = require("../../../Spinner");
const StackView_1 = require("../../../StackView");
const View_1 = require("../../../View");
exports.LoginSSO = react_1.default.memo(function LoginSSO({ loading, logIn, busyModel, onRequestMFACode, maxLengthLogin, texts: customTexts }) {
    const texts = Object.assign({}, constants_1.LOGIN_SSO_DEFAULT_TEXTS, customTexts);
    const inputRef = (0, hooks_1.useAutoFocus)();
    const form = (0, core_1.useForm)({ login: '' }, {
        validationSchema: {
            login: [
                (0, core_1.required)(texts.errorRequired),
                (0, maxLength_1.maxLength)(maxLengthLogin, texts.errorMaxLength)
            ]
        }
    });
    const { value: { loading: internalLoading } } = (0, core_1.useModel)(busyModel);
    const { submit, errorHighlight, fieldFocusHandler, keyDownHandler, hasError, error } = (0, hooks_1.useLoginFormSubmit)({
        form,
        handler: logIn,
        busyModel,
        onRequestMFACode: () => onRequestMFACode(form.getValue().login)
    });
    loading = loading || internalLoading;
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, spaceTop: hasError ? View_1.INDENT.none : View_1.INDENT.l, onKeyDown: keyDownHandler },
        hasError && react_1.default.createElement(ErrorMessage_1.ErrorMessage, null, error),
        react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.m },
            react_1.default.createElement(FormLayout_1.FormLayout, { disabled: loading },
                react_1.default.createElement(fields_1.TextField, { field: form.fields.login, controlRef: inputRef, placeholder: texts.placeholderLogin, size: public_1.CONTROL_SIZE.full, hasError: errorHighlight, onFocus: fieldFocusHandler })),
            react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center },
                react_1.default.createElement(LoginSSO_styles_1.StyledLoginSSOButton, { type: "submit", onClick: submit, disabled: loading }, texts.actionLogIn),
                loading && react_1.default.createElement(Spinner_1.Spinner, null)))));
});
//# sourceMappingURL=LoginSSO.js.map